export default __webpack_public_path__ + "static/media/intro-pic2.e0522366.jpg";